/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DocumentsUploadRouteImport } from './routes/documents.upload'
import { Route as DocumentsNewAiRouteImport } from './routes/documents.new-ai'
import { Route as DocumentsIdRouteImport } from './routes/documents.$id'
import { Route as AdminUsersRouteImport } from './routes/admin.users'
import { Route as AdminAuditRouteImport } from './routes/admin.audit'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentsUploadRoute = DocumentsUploadRouteImport.update({
  id: '/documents/upload',
  path: '/documents/upload',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentsNewAiRoute = DocumentsNewAiRouteImport.update({
  id: '/documents/new-ai',
  path: '/documents/new-ai',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentsIdRoute = DocumentsIdRouteImport.update({
  id: '/documents/$id',
  path: '/documents/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAuditRoute = AdminAuditRouteImport.update({
  id: '/admin/audit',
  path: '/admin/audit',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRoute
  '/login': typeof LoginRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/users': typeof AdminUsersRoute
  '/documents/$id': typeof DocumentsIdRoute
  '/documents/new-ai': typeof DocumentsNewAiRoute
  '/documents/upload': typeof DocumentsUploadRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRoute
  '/login': typeof LoginRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/users': typeof AdminUsersRoute
  '/documents/$id': typeof DocumentsIdRoute
  '/documents/new-ai': typeof DocumentsNewAiRoute
  '/documents/upload': typeof DocumentsUploadRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRoute
  '/login': typeof LoginRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/users': typeof AdminUsersRoute
  '/documents/$id': typeof DocumentsIdRoute
  '/documents/new-ai': typeof DocumentsNewAiRoute
  '/documents/upload': typeof DocumentsUploadRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/login'
    | '/admin/audit'
    | '/admin/users'
    | '/documents/$id'
    | '/documents/new-ai'
    | '/documents/upload'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dashboard'
    | '/login'
    | '/admin/audit'
    | '/admin/users'
    | '/documents/$id'
    | '/documents/new-ai'
    | '/documents/upload'
  id:
    | '__root__'
    | '/'
    | '/dashboard'
    | '/login'
    | '/admin/audit'
    | '/admin/users'
    | '/documents/$id'
    | '/documents/new-ai'
    | '/documents/upload'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRoute: typeof DashboardRoute
  LoginRoute: typeof LoginRoute
  AdminAuditRoute: typeof AdminAuditRoute
  AdminUsersRoute: typeof AdminUsersRoute
  DocumentsIdRoute: typeof DocumentsIdRoute
  DocumentsNewAiRoute: typeof DocumentsNewAiRoute
  DocumentsUploadRoute: typeof DocumentsUploadRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documents/upload': {
      id: '/documents/upload'
      path: '/documents/upload'
      fullPath: '/documents/upload'
      preLoaderRoute: typeof DocumentsUploadRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documents/new-ai': {
      id: '/documents/new-ai'
      path: '/documents/new-ai'
      fullPath: '/documents/new-ai'
      preLoaderRoute: typeof DocumentsNewAiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documents/$id': {
      id: '/documents/$id'
      path: '/documents/$id'
      fullPath: '/documents/$id'
      preLoaderRoute: typeof DocumentsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/audit': {
      id: '/admin/audit'
      path: '/admin/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AdminAuditRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRoute: DashboardRoute,
  LoginRoute: LoginRoute,
  AdminAuditRoute: AdminAuditRoute,
  AdminUsersRoute: AdminUsersRoute,
  DocumentsIdRoute: DocumentsIdRoute,
  DocumentsNewAiRoute: DocumentsNewAiRoute,
  DocumentsUploadRoute: DocumentsUploadRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
